import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/login-log";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
  sdate?: string;
  edate?: string;
  search?: string;
};

export class loginLogApi extends BaseAPI {
  static getLoginHistory(query: listType): Promise<AxiosResponse> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
}
